




























import { computed, defineComponent, Ref, ref } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';

export default defineComponent({
  name: 'PermissionHelp',
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  setup(props, context) {
    const vm = context.root;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const columns = [
      {
        align: 'center',
        title: i18n_t('角色'),
        colKey: 'name',
        children: [
          {
            align: 'center',
            colKey: 'permisson',
            title: i18n_t('权限'),
            width: 110,
          },
        ],
      },
      {
        align: 'center',
        colKey: 'enterpriseSpace',
        title: i18n_t('企业空间'),
        children: [
          {
            align: 'center',
            colKey: 'enManager',
            title: i18n_t('管理员'),
            width: i18n.locale === 'zh-CN' ? 90 : 110,
          },
          {
            align: 'center',
            colKey: 'enUploader',
            title: i18n_t('上传者'),
            width: 90,
          },
          {
            align: 'center',
            colKey: 'enOthers',
            title: i18n_t('其他成员'),
            width: 90,
          },
        ],
      },
      {
        align: 'center',
        colKey: 'coSpace',
        title: i18n_t('协作空间'),
        children: [
          {
            align: 'center',
            colKey: 'coCreator',
            title: i18n_t('创建者'),
            width: 90,
          },
          {
            align: 'center',
            colKey: 'coUploader',
            title: i18n_t('上传者'),
            width: 90,
          },
          {
            align: 'center',
            colKey: 'coOthers',
            title: i18n_t('其他成员'),
            width: 90,
          },
        ],
      },
      {
        align: 'center',
        colKey: 'personalSpace',
        title: i18n_t('个人空间'),
        children: [
          {
            align: 'center',
            colKey: 'owner',
            title: i18n_t('拥有者'),
            width: 90,
          },
        ],
      },
    ];

    const renderList = [
      {
        id: 1,
        permisson: i18n_t('删除'),
        enManager: true,
        enUploader: true,
        enOthers: false,
        coCreator: true,
        coUploader: true,
        coOthers: false,
        owner: true,
      },
      {
        id: 2,
        permisson: i18n_t('信任'),
        enManager: true,
        enUploader: false,
        enOthers: false,
        coCreator: true,
        coUploader: false,
        coOthers: false,
        owner: false,
      },
    ];

    return {
      innerShow,
      columns,
      renderList,
    };
  },
});
